import conversations from "./conversations";

export const CONVERSATIONS_NAMESPACE = "conversations";

export default conversations;
